import { getFunctions, httpsCallable } from "firebase/functions";

const fn = (name) => httpsCallable(getFunctions(), name);

export const ResearchAgent = {
  async research(lead) {
    const call = fn("growthResearchLead");
    const result = await call({ lead });
    return result.data.research;
  },

  async batchResearch(leads, onProgress) {
    const results = [];
    for (let i = 0; i < leads.length; i++) {
      try {
        const research = await ResearchAgent.research(leads[i]);
        results.push({ leadId: leads[i].id, research, error: null });
      } catch (err) {
        results.push({ leadId: leads[i].id, research: null, error: err.message });
      }
      if (onProgress) onProgress(i + 1, leads.length);
      if (i < leads.length - 1) await new Promise((r) => setTimeout(r, 500));
    }
    return results;
  },
};
